import Api from '@/services/api'

export default {
  namespaced: true,
  state: {
    // list of influencers
    list: null,
    total: 0,
    has_more: false,

    // influencer details
    profile: null,

    // influencer packages
    packages: null,
    packages_raw: null,
    package_settings: null,
    pricing_minimum: null,
    extra_package: null,

    // others
    categories: [],
    top_list: [],
    list_type: [],
    list_results: [],
    errorMessage: '',
  },

  mutations: {
    setProfile(state, data) {
      state.profile = data
    },

    clearProfile(state) {
      state.profile = null
    },

    setList(state, data) {
      if (!state.list || !state.list_results) {
        data.type === 'search'
          ? (state.list_results = data.influencers)
          : (state.list = data.influencers)
      } else {
        state.list = state.list.concat(data.influencers)
      }

      if (data.meta) {
        state.has_more = !!data.meta.last_page
        state.total = data.meta.total
      } else {
        state.has_more = !!data.next_page_url
        state.total = data.total
      }
    },

    clearList(state) {
      state.list = null
      state.list_results = []
    },

    clearTopList(state) {
      state.top_list = []
    },

    setPackageSettings(state, data) {
      state.package_settings = data
    },

    setPackageMinimum(state, data) {
      state.pricing_minimum = data
    },

    setPackageNewPricing(state, data) {
      state.packages_raw = data
      state.packages = {}

      let packageTypes = Object.keys(data)

      packageTypes.forEach((type) => {
        let plans = data[type]

        if (type === 'augmented' || type === 'single') {
          plans = {}
          plans.pack = type === 'single' ? 'Standard' : 'AR'
          plans.plan = data[type]
          plans.plan.name = type === 'single' ? 'Standard' : 'AR'
          state.packages[type] = plans
        } else {
          state.packages[type] = plans
        }
      })
    },

    setPackagePricing(state, data) {
      let packageTypes = Object.keys(data)

      state.packages_raw = data
      state.packages = {}

      packageTypes.forEach((type) => {
        let plans = data[type]

        if (plans instanceof Array) {
          // filter active plans
          plans = plans.filter(function (plan) {
            return plan.is_active
          })

          // if no plans activated, disable package
          if (plans.length === 0) {
            state.package_settings[`is_` + type + `_pack_enabled`] = false
          }

          state.packages[type] = {
            options: [],
            default: {},
          }

          // find center index
          let center = Math.floor((plans.length - 1) / 2)

          plans.forEach((plan, key) => {
            // radio options
            state.packages[type].options[key] = {
              pack: plan.quantity,
              plan,
            }

            if (key === center) {
              // set default selected package
              state.packages[type].default = state.packages[type].options[key]
            }
          })
        } else {
          state.packages[type] = plans
        }
      })
    },

    setExtraPricing(state, data) {
      state.extra_package = data
    },

    setInfluencerCategories(state, data) {
      state.categories = data.categories
    },

    setToplists(state, data) {
      state.top_list = data.top_lists

      if (!state.list_type.length) {
        data.top_lists.forEach((top) => {
          state.list_type.push(top.list_type)
        })
      }
    },

    clearPackages(state) {
      state.packages = null
      state.packages_raw = null
      state.package_settings = null
      state.pricing_minimum = null
    },

    handleError(state, error) {
      if (error.response && error.response.data) {
        state.errorMessage = error.response.data.message
      }
    },
  },

  actions: {
    async getProfile({ commit }, influencerUID) {
      await Api.get(`influencer/${influencerUID}`)
        .then(({ data }) => {
          commit('setProfile', data.data)
        })
        .catch((error) => {
          commit('handleError', error)
        })
    },

    async getFollowing({ commit }, params) {
      await Api.get(
        `influencer/following?limit=${params.limit}&page=${params.page}&search=${params.search}`
      )
        .then(({ data }) => {
          commit('setList', data.data)
        })
        .catch((error) => {
          commit('handleError', error)
        })
    },

    async getRandomInfluencer({ commit }, params) {
      await Api.get(
        `influencer/suggestions?limit=${params.limit}&page=${params.page}`
      )
        .then(({ data }) => {
          commit('setList', data.data)
        })
        .catch((error) => {
          commit('handleError', error)
        })
    },

    async searchInfluencer({ commit }, params) {
      await Api.get(
        `influencers?search=${params.keyword}&category_id=${params.catid}&sort_by=${params.sortby}&page=${params.page}&per_page=${params.perpage}`
      )
        .then(({ data }) => {
          data.data.type = 'search'
          commit('setList', data.data)
        })
        .catch((error) => {
          commit('handleError', error)
        })
    },

    async getVIP({ commit }, params) {
      await Api.get(
        `influencer/all/vip?limit=${params.limit}&page=${params.page}&search=${params.search}`
      )
        .then(({ data }) => {
          commit('setList', data.data)
        })
        .catch((error) => {
          commit('handleError', error)
        })
    },

    async getPackagePricing({ commit }, influencerUID) {
      await Api.get(`influencer/${influencerUID}/package/new-pricing`).then(
        ({ data }) => {
          commit('setPackageMinimum', data.data.pricing_minimum)
          commit('setPackageSettings', data.data.package_settings)
          commit('setPackageNewPricing', data.data.package_pricing)
        }
      )
    },

    async getExtraPricing({ commit }, influencerUID) {
      await Api.get(`influencer/${influencerUID}/package/pricing/extra`).then(
        ({ data }) => {
          commit('setExtraPricing', data.data.extra_pricing)
        }
      )
    },

    async getInfluencerCategories({ commit }) {
      await Api.get(`influencer/categories/all`).then(({ data }) => {
        commit('setInfluencerCategories', data.data)
      })
    },

    async getToplist({ commit }, params) {
      await Api.get(`influencers/toplists?category_id=${params || ``}`)
        .then(({ data }) => {
          commit('setToplists', data.data)
        })
        .catch((error) => {
          commit('handleError', error)
        })
    },
  },
}
